export class CreateSnapshotRecipeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "baseSnapshotId",
            "baseName": "baseSnapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "proposal",
            "baseName": "proposal",
            "type": "SnapshotRecipeProposal",
            "format": ""
        },
        {
            "name": "rules",
            "baseName": "rules",
            "type": "Array<SnapshotRecipeRule>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateSnapshotRecipeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
